import { createTheme } from '@mui/material';

import { componentsConfigs } from '../components';
import { layoutConfigs } from '../layout';
import { shadowsConfigs } from '../shadows';
import { getTypographyConfigs } from '../typography';
import { fontFamily } from './fonts';
import { paletteConfigs } from './palette';

export const caymanTheme = createTheme({
  components: componentsConfigs,
  typography: getTypographyConfigs(fontFamily.primary),
  palette: paletteConfigs,
  shadows: shadowsConfigs,
  ...layoutConfigs,
});
